import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import $ from 'jquery';

import { AuthUrlContext } from '../../context/createContext';
import { BrandLogo, CommonAccordion, UserDetails } from './index';



const SettingIcon = <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x={0}
    y={0}
    viewBox='0 0 512 512'
    xmlSpace='preserve'
    className='icon cursor-pointer icon-lg align-text-bottom'
>
    <path d='M258.3 149.8c-57.3 0-103.9 46.6-103.9 103.9 0 57.3 46.6 103.9 103.9 103.9s104-46.6 104-103.9c0-57.3-46.6-103.9-104-103.9zm0 175.9c-39.7 0-71.9-32.3-71.9-71.9 0-39.7 32.3-71.9 71.9-71.9 39.7 0 71.9 32.3 71.9 71.9.1 39.6-32.2 71.9-71.9 71.9z' />
    <path d='M491.4 202.9l-38.7-14c-3-9.5-6.6-18.6-10.7-27.1l18.3-38.3c5.6-11.8 3.2-26-6-35.2l-30.5-30.6c-9.3-9.3-23.4-11.7-35.2-6.1l-38.2 18.1c-8.1-3.8-16.7-7.1-27.1-10.3l-14-38.7C304.9 8.5 293.2.4 280.2.4h-43.6c-12.9 0-24.6 8.2-29.1 20.4l-14.1 38.8c-9.7 3.1-18.8 6.7-27.1 10.7l-38.2-18.4c-11.8-5.6-26-3.2-35.2 6L62.1 88.3c-9.3 9.3-11.7 23.5-6 35.3l18 37.8c-5.2 9.8-9.2 18.7-12.2 27l-40.8 14.2C8.6 207 .2 218.7.2 232v43.3c0 13.2 8.4 25 20.7 29.2l40.9 14.3c3.1 8.8 6.9 17.7 11.7 27.1L55.6 384c-5.6 11.9-3.2 26 6.2 35.2L92.6 450c9.2 9.2 23.4 11.7 35.2 6l38.1-18.1c9.7 5.2 18.6 9.2 27.1 12.2l14.2 40.8c4.3 12.5 16 20.8 29.3 20.8h43.3c13.2 0 25-8.4 29.3-20.8l14.2-40.9c8.9-3.1 18-7 27.1-11.7l38.1 17.9c11.8 5.6 26 3.1 35.3-6.2l30.7-30.9c9.2-9.2 11.6-23.3 6-35.2l-18.2-38.4c3.8-8 7.1-16.6 10.3-27.1l38.6-14c12.3-4.3 20.6-16 20.6-29V232c0-13-8.2-24.7-20.4-29.1zm-11.6 71.8l-38.5 14c-9.2 3.3-16.1 10.6-19 19.9v.1c-2.8 9.3-5.7 16.8-8.9 23.5-4.1 8.5-4.2 18.3-.1 26.7l18.2 38.3-29.7 29.9-38-17.9c-8.9-4.1-18.8-4-27.3.5-8 4.1-16 7.6-23.7 10.3-8.9 2.9-16.1 10.1-19.3 19.1l-14.2 40.7h-41.8L223.2 439c-3.1-8.9-10-15.9-19-19-7.3-2.6-15-6.1-23.7-10.7s-19.1-4.8-27.9-.6l-37.9 18-29.9-29.8 17.9-37.9c4.1-8.9 4-18.9-.5-27.3-4.3-8.3-7.7-16.1-10.3-23.9-3.1-8.9-10.2-16-19.1-19.1l-40.6-14.2v-41.8l40.7-14.2c8.9-3.1 15.9-10 19-18.9 2.5-7 6-14.7 10.7-23.5 4.6-8.6 4.9-19 .6-27.9l-18-37.8L115 80.9l38 18.3c8.5 4.1 18.6 4 27.1-.2 7.1-3.5 15.1-6.6 23.6-9.3 9-2.9 16.3-9.9 19.6-19l14-38.5h42.1l13.9 38.4c3.3 9.2 10.6 16.1 19.9 19h.1c9.2 2.8 16.6 5.6 23.4 8.9 8.6 4.1 18.3 4.1 26.8.1l38-18 29.5 29.6-18.2 38-.1.2c-4 8.7-4 18.5.2 26.9 3.6 7.4 6.7 15.3 9.3 23.5 2.7 9 9.8 16.4 18.9 19.8l38.5 14v42.1z' />
</svg>

const NewSideBar = () => {

    const [activeOption, setActiveOption] = useState('');

    let navigate = useNavigate();
    const { userRights } = useContext(AuthUrlContext)
    const { urlList, userRole } = userRights

    let isSuperAdmin = userRole === "ROLE_SUPER_ADMIN";

    return (
        <div id='left-sidebar' className='sidebar mini_sidebar_on'>
            <BrandLogo />
            <div
                className='slimScrollDiv'
                style={{
                    position: 'relative',
                    overflow: 'auto',
                    width: 'auto',
                    height: 'calc(100vh - 65px)',
                }}
            >
                <div
                    className='sidebar-scroll'
                    style={{
                        overflow: 'auto',
                        width: 'auto',
                        height: 'calc(100vh - 65px)',
                    }}
                >
                    <UserDetails />
                    <nav id='left-sidebar-nav' className='sidebar-nav'>
                        <ul id='main-menu' className='metismenu main-div'>
                            <Link to='/'>
                                <CommonAccordion title='Home' Icon={<i className='icon-home'></i>} />
                            </Link>
                            <CommonAccordion title='Sales' Icon={<i className='fa fa-list-ul'></i>}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/items/getAllRecords")) && <Link to='/items' className='ember-view p-0' id='ember170'>
                                        Items
                                    </Link>}

                                    {(isSuperAdmin || urlList.has("/items/")) && <Link to='/items/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}

                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has(("/itemPriceList/getAllRecords"))) && <Link to='/pricelists' className='ember-view p-0' id='ember170'>
                                        Price Lists
                                    </Link>}

                                    {(isSuperAdmin || urlList.has(("/itemPriceList/"))) && <Link to='/pricelist/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}

                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has(("/issuance/getAllRecords"))) && <Link to='/issueitems' className='ember-view p-0' id='ember170'>
                                        Issue Items
                                    </Link>}

                                    {(isSuperAdmin || urlList.has(("/issuance/"))) && <Link to='/issueitems/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/stockClosing/warehouseList/{warehouse}")) && <Link to='/stockClosing/list' className='ember-view p-0' id='ember170'>
                                        Stock Closing
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/stockClosing/{uuid}")) && <Link to='/stockClosing/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}

                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/wastage/warehouseList/{uuid}")) && <Link to='/wastage/list' className='ember-view p-0' id='ember170'>
                                        Wastage
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/wastage/{uuid}")) && <Link to='/wastage/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                            </CommonAccordion>

                            <CommonAccordion title='Inventory' Icon={<i className='fa fa-shopping-cart'></i>}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/customer/getAllRecords")) && <Link to='/contacts' className='ember-view p-0' id='ember170'>
                                        Customers
                                    </Link>}

                                    {(isSuperAdmin || urlList.has("/customer/")) && <Link to='/contacts/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/salesOrder/getAllRecords")) && <Link to='/salesorders' className='ember-view p-0' id='ember170'>
                                        Sales Orders
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/salesOrder/")) && <Link to='/salesorders/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/invoice/getAllRecords")) && <Link to='/invoices' className='ember-view p-0' id='ember170'>
                                        Invoices
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/invoice/addDirectInvoiceRecord")) && <AddIcon
                                        onClick={() =>
                                            navigate(`/directInvoices`, {
                                                state: { directInvoice: true },
                                            })
                                        }
                                    />}
                                </div>
                                {(isSuperAdmin || urlList.has("/CreditNoteView/")) && <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/CreditNoteView/' className='ember-view p-0' id='ember170'>
                                        Credit Note
                                    </Link>
                                    <AddIcon />
                                </div>}

                                {(isSuperAdmin || urlList.has("/recordPayment/getAllRecords")) && <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/salesPaymentlist' className='ember-view p-0' id='ember170'>
                                        Payments
                                    </Link>
                                </div>}
                            </CommonAccordion>

                            <CommonAccordion title='Purchase' Icon={<i className='fa fa-shopping-bag'></i>}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/vendor/getAllRecords")) && <Link to='/vendors' className='ember-view p-0' id='ember170'>
                                        Vendors
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/vendor/")) && <Link to='/vendors/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/purchaseOrder/getAllRecords")) && <Link to='/purchase/' className='ember-view p-0' id='ember170'>
                                        Purchase
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/purchaseOrder/")) && <Link to='/purchase/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/bill/getAllRecords")) && <Link to={'/bills'} className='ember-view p-0' id='ember170'>
                                        GRN
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/bill/addDirectBillRecord/")) && <AddIcon
                                        onClick={() =>
                                            navigate(`/DirectBill`, {
                                                state: { directBill: true },
                                            })
                                        }
                                    />}
                                </div>
                                {(isSuperAdmin || urlList.has("/debitNote/getAllRecords")) && <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/DebitNoteView/' className='ember-view p-0' id='ember170'>
                                        Debit Note
                                    </Link>
                                    <AddIcon />
                                </div>}

                                {/* <div className='d-flex justify-content-between align-items-center'>
                                        {(isSuperAdmin || urlList.has("/PurchasePayment/getAllRecords")) && <Link to={'/purchasePaymentlist'} className='ember-view p-0' id='ember170'>
                                            Payments
                                        </Link>}
                                    </div> */}

                            </CommonAccordion>

                            {/* production */}
                            <CommonAccordion title='Production' Icon={<i className='fa fa-industry'></i>}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/recipe/getAllRecords")) && <Link to='/recipe' className='ember-view p-0' id='ember170'>
                                        Recipe
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/recipe/")) && <Link to='/recipe/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/batches/getAllRecords")) && <Link to='/batches' className='ember-view p-0' id='ember170'>
                                        Today's Production
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/batches/")) && <Link to='/batches/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {(isSuperAdmin || urlList.has("/requisition/getAllRecords")) && <Link to='/requisition' className='ember-view p-0' id='ember170'>
                                        Requisition
                                    </Link>}
                                    {(isSuperAdmin || urlList.has("/requisition/")) && <Link to='/requisition/new' className='ember-view p-0' id='ember171'>
                                        <AddIcon />
                                    </Link>}
                                </div>
                            </CommonAccordion>

                            <Link to='/reports' className='ember-view p-0' id='ember171'>
                                <CommonAccordion title='Reports' Icon={<i className='fa fa-bar-chart'></i>} />
                            </Link>
                            <CommonAccordion title='Settings' Icon={SettingIcon}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <Link
                                        to='/settings/Preferences/orgList'
                                        id='ember761'
                                        className={activeOption === 'orgProfile' ? 'nav-link text-nowrap ember-view active' : 'nav-link text-nowrap ember-view'}
                                    >
                                        Organization
                                    </Link>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/settings/Preferences/userRole' className={activeOption === 'userRole' ? 'nav-link active ember-view' : 'nav-link ember-view'}>
                                        User Roles
                                    </Link>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/settings/Preferences/warehouse' id='ember765' className={activeOption === 'warehouse' ? 'nav-link active ember-view' : 'nav-link ember-view'}>
                                        Warehouses
                                    </Link>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/settings/preferences/DepartmentList' id='ember769' className='nav-link ember-view'>
                                        Preferences
                                    </Link>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <Link to='/settings/Preferences/taxes/taxList' id='ember773'>
                                        Taxes
                                    </Link>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {/* <li id='ember772' className={userRole === 'ROLE_SUPER_ADMIN' ? 'd-block' : 'd-none'}>
                                        <Link to='/settings/eWay'>E Way</Link>
                                    </li> */}
                                </div>
                            </CommonAccordion>

                        </ul>
                    </nav>
                </div>
                <div
                    className='slimScrollBar'
                    style={{
                        background: 'rgb(28, 34, 44)',
                        width: '2px',
                        position: 'absolute',
                        top: '0px',
                        opacity: '0.4',
                        display: 'block',
                        borderRadius: '3px',
                        zIndex: '99',
                        right: '1px',
                        height: '255.162px',
                    }}
                ></div>
                <div
                    className='slimScrollRail'
                    style={{
                        width: '2px',
                        height: '100%',
                        position: 'absolute',
                        top: '0px',
                        display: 'none',
                        borderRadius: '7px',
                        background: 'rgb(51, 51, 51)',
                        opacity: '0.2',
                        zIndex: '90',
                        right: '1px',
                    }}
                ></div>
            </div>
        </div>
    )
}

export default NewSideBar
